import { render, staticRenderFns } from "./uploadvideo.vue?vue&type=template&id=5c450231&scoped=true&"
import script from "./uploadvideo.vue?vue&type=script&lang=js&"
export * from "./uploadvideo.vue?vue&type=script&lang=js&"
import style0 from "./uploadvideo.vue?vue&type=style&index=0&id=5c450231&prod&lang=css&"
import style1 from "./uploadvideo.vue?vue&type=style&index=1&id=5c450231&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c450231",
  null
  
)

export default component.exports